import { Alert } from '@chakra-ui/react'

/** The backend's missing-rate message, reused as approved for SIB-1029. */
export const MISSING_VAT_RATE_HINT = 'Bitte hinterlegen Sie Ihren Umsatzsteuersatz in den Rechnungsdaten.'

/**
 * Shown on the invoice settings pages that save without the rate field (automation, texts)
 * while no rate is stored: their saves are rejected until one is entered on the data page.
 */
export function MissingVatRateHint() {
  return (
    <Alert.Root status="warning" colorPalette="yellow" data-testid="missing-vat-rate-hint">
      <Alert.Indicator />
      <Alert.Content>
        <Alert.Description>{MISSING_VAT_RATE_HINT}</Alert.Description>
      </Alert.Content>
    </Alert.Root>
  )
}
